// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__y9r6y","gfeWrapper":"CalendarEvent_gfeWrapper__12tXE"};